import { Pipe, PipeTransform } from '@angular/core';

import { truncate, TruncateOptions } from 'lodash';

@Pipe({
  name: 'truncate'
})
export class TruncatePipe implements PipeTransform {

  transform(string?: string, options: TruncateOptions = { length: 100 }): any {
    // const re = new RegExp('^(.{' + length + '}).+');
    // return str.replace(re, '$1&hellip;');
    return truncate(string, options);
  }

}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/pipes/truncate.pipe.ts